import { SlideContent } from '@/components/SlideContent';
import { OnboardingLayout, useSlideSetup } from '@/features/client-onboarding';
import { OnboardingFundingCoverage } from '@/pages/OnboardingFundingCoverage';
import { PolicyApplicationDashboard } from '@/pages/PolicyApplicationDashboard';
import { selectClient } from '@/model/selectors';

import { fullName } from '@shared';

import { useSelector } from 'react-redux';

export function OnboardingPolicyApplicationDashboard({
  clientId,
}: ClientIdProps) {
  const client = useSelector(selectClient);
  const clientName = fullName(client);

  useSlideSetup({
    slidePage: OnboardingPolicyApplicationDashboard,
    nextSlidePage: OnboardingFundingCoverage,
    nextButtonLabel: 'Next',
  });

  return (
    <OnboardingLayout>
      <SlideContent
        headerText={`Insurance Application Review `}
        headerSubText={`Review and manage insurance applications for ${clientName}.`}
        centerHeader={true}
      >
        <div className="mt-2 md:mt-8">
          <PolicyApplicationDashboard />
        </div>
      </SlideContent>
    </OnboardingLayout>
  );
}
